import {ProductGroup} from "./product.group";
import {Product} from "./product";
import {ProductBehaviour} from "./product_behaviour";

export class Field<T> {
    index: number;
    value: T;

    constructor(index: number, val?: T) {
        this.index = index;
        this.value = val;
    }

    setValue(val: T) {
        this.value = val;
    }

    /**
     *
     * @returns {T}
     */
    getValue() {
        return this.value;
    }

    /**
     *
     * @returns {string}
     */
    getType() {
        return typeof(this.value);
    };
}

export interface SubProductSelectedEvent {
    product: Product,
    subProduct: SubProduct,
    productGroup: ProductGroup
}

export interface SubProductTabSelectedEvent {
    productGroup: ProductGroup,
    action: string
}


interface SubProductInterface {
    id: Field<number>;
    articleNumber: Field<string>;
    title: Field<string>;
    subtitle: Field<string>;
    description: Field<string>;
    price: Field<number>;
    thumbPath1: Field<string>;
    renderPath: Field<string>;
    isSelected: boolean;
}

export interface InputSubProductInterface {
    ID: string;
    ArticleNumber: string;
    Title: string;
    Subtitle: string;
    Description: string;
    Price: string;
    ThumbPath01: string;
    RenderPath: string;
    url: string;
}

export class SubProduct implements SubProductInterface, ProductBehaviour {
    id: Field<number>;
    articleNumber: Field<string>;
    title: Field<string>;
    subtitle: Field<string>;
    description: Field<string>;
    price: Field<number>;
    thumbPath1: Field<string>;
    renderPath: Field<string>;
    isSelected: boolean;
    url: Field<string>;

    private group: ProductGroup = null;

    constructor(data: InputSubProductInterface) {
        this.initFields(data);
    }

    /**
     *
     * @param index {number}
     * @returns {any|Field}
     */
    private getFieldByIndex(index) {
        for (let fieldName in this) {
            if (this.hasOwnProperty(fieldName) && this[fieldName] instanceof Field) {
			    let field = <Field<any>><any>this[fieldName];
                if (field.index === index) {
                    return field;
                }
            }
        }
        return null;
    }

    public registerInGroup(group: ProductGroup)
    {
        this.group = group;
        return this;
    }

    public getGroup(): ProductGroup{
        return this.group;
    }

    public getGroupName(){
        return this.group.getName();
    }


    private initFields(data: InputSubProductInterface) {
        this.id = new Field<number>(0, parseInt(data.ID));
        this.articleNumber = new Field<string>(1, data.ArticleNumber);
        this.title = new Field<string>(2, data.Title);
        this.subtitle = new Field<string>(3, data.Subtitle);

        if (data.Price.trim().length == 0) {
            data.Price = "0";
        }
        this.price = new Field<number>(6, parseInt(data.Price));

        let thumbPath = typeof data['ThumbPath01'] !== 'undefined' ? data.ThumbPath01 : (typeof data['Thumbpath01'] !== 'undefined' ? data['Thumbpath01'] : (typeof data['thumbpath01'] !== 'undefined' ? data['thumbpath01'] : ""));
        let renderPath = typeof data['RenderPath'] !== 'undefined' ? data.RenderPath : (typeof data['Renderpath'] !== 'undefined' ? data['Renderpath'] : (typeof data['renderpath'] !== 'undefined' ? data['renderpath'] : ""));
        this.thumbPath1 = new Field<string>(7, thumbPath);
        this.renderPath = new Field<string>(8, renderPath);
        this.url = new Field<string>(9, data.url);
    }

}


// WEBPACK FOOTER //
// ./src/app/model/subproduct.ts